import { useRef } from 'react';

import '../Styles/Info.css';

export default function Info(props) {
	const { show, onToggle, language } = props;
	const contentDivRef = useRef(null);
	const closeButtonRef = useRef(null);

	//const showImage = () => (language) ? (language['map:info:image']) ? JSON.parse(language['map:info:image']).image : '' : '';

	return (
		<div className={show ? 'modal-info-wrapper show': 'modal-info-wrapper'}>
			<div className={show ? 'modal-info show': 'modal-info'}>
				<div className='modal-info-header-wrapper'>
					<div className='header'>{(language) ? language['map:info:title'] : 'Map information'}</div>
					<button
						ref={closeButtonRef}
						className='button-close'
						onClick={onToggle}
						aria-label={(language) ? language['aria:buttons:close'] : 'Close window'}
					></button>
				</div>
				<div
					tabIndex={0}
					ref={contentDivRef}
					className='content scroller'
				>
					<div
						className='description'
						dangerouslySetInnerHTML={{ __html: (language) ? language['map:info:content'] : '' }}
					></div>
				</div>
			</div>
		</div>
	);
}
